import React, { useEffect, useRef } from 'react';
import { MapContainer as OriginalMapContainer, MapContainerProps } from 'react-leaflet';
import { Map as LeafletMap } from 'leaflet';

interface ExtendedMapContainerProps extends MapContainerProps {
  onMapReady?: (map: LeafletMap) => void; // Rename whenCreated to onMapReady for clarity
}

export const MapContainer = React.forwardRef<LeafletMap, ExtendedMapContainerProps>(
  ({ onMapReady, ...props }, ref) => {
    const mapRef = useRef<LeafletMap | null>(null);

    useEffect(() => {
      if (mapRef.current && onMapReady) {
        onMapReady(mapRef.current); // Trigger the onMapReady callback
      }
    }, [onMapReady]);

    return (
      <OriginalMapContainer
        {...props}
        ref={(mapInstance) => {
          if (mapInstance) {
            mapRef.current = mapInstance; // Set the map instance to the internal ref
            if (ref && typeof ref === 'object' && ref !== null) {
              (ref as React.MutableRefObject<LeafletMap | null>).current = mapInstance; // Set the map instance to the forwarded ref
            }
          }
        }}
      />
    );
  }
);

export default MapContainer;